import { FaxFileTypes } from 'generated/graphql-types';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { FaxFileTypeOption } from '../models/fax-file-type-option.interface';
import { faxFileTypeOptionActions } from './fax-file-type-option.actions';

export const faxFileTypeOptionFeatureKey = 'faxFileTypeOptions';

export type FaxFileTypeOptionState = EagerSelectState<FaxFileTypeOption>;

const adapter = createEagerSelectAdapter<FaxFileTypeOptionState, FaxFileTypeOption>({
   featureKey: faxFileTypeOptionFeatureKey,
   selectId: (faxFileType: FaxFileTypeOption) => {
      return faxFileType.faxFileTypeId ?? '';
   },
});

export const faxFileTypeOptionSelectors = adapter.getSelectors(filterFaxFileTypeOption);

const initialState = adapter.getInitialState();

export const faxFileTypeOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   faxFileTypeOptionActions.search,
   faxFileTypeOptionActions.searchReset,
   faxFileTypeOptionActions.loadFromApi,
   faxFileTypeOptionActions.loadFromApiSuccess,
   faxFileTypeOptionActions.loadFromApiFailure
);

export function filterFaxFileTypeOption<T extends FaxFileTypeOption>(
   types: T[],
   searchText: string | null | undefined
): T[] {
   const filteredOptions: T[] = Object.values(FaxFileTypes)
      .filter((faxFileType) => {
         if (searchText) {
            return faxFileType.toLowerCase().includes(searchText.toLowerCase());
         } else {
            return true;
         }
      })
      .map((faxFileTypeId) => {
         return { faxFileTypeId } as T;
      });
   return filteredOptions;
}
